
import { useEffect, useState } from "react";
import Loading from "../../../load/loading";
import Date from "../../../utils/date";
import api from "../../../services/api";
import CreateBanner from "./createBanner";
import MessageSuccess from '../../../messages/messageSuccess';
import MessageError from "../../../messages/messageError";
import HeaderSession from "../../../utils/headerSession";
import HeaderGestorConfigs from "../../../utils/headerGestorConfigs";
import DeleteBanner from "./deleteBanner";
import RegisterAccess from "../../../utils/registerAccess";
import Slider from "../../../pages/home/slider/slider";
// import RegisterAccess from "../../../utils/registerAccess";

const AddIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        className="tw-h-8 tw-w-8"
        aria-hidden="true"
    >
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 5v14m-7-7h14" />
    </svg>
)

const BannerCard = ({ banner, onEdit, onDelete }) => (
    <article className="tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-white tw-p-4 tw-shadow-sm tw-transition hover:tw-shadow-md">
        <RegisterAccess page={'banners'} />

        <div className="tw-flex tw-flex-col tw-gap-4 md:tw-flex-row">
            <div className="tw-shrink-0">
                <img
                    src={banner.imagem}
                    alt={banner.titulo || 'Banner'}
                    className="tw-h-[150px] tw-w-full tw-max-w-[300px] tw-rounded-lg tw-object-cover tw-transition hover:tw-opacity-80"
                />
            </div>

            <div className="tw-relative tw-min-w-0 tw-flex-1">
                {banner?.titulo && (
                    <h3 className="tw-mb-2 tw-text-base tw-font-semibold tw-text-slate-900">
                        {banner.titulo}
                    </h3>
                )}

                {banner?.descricao && (
                    <p className="tw-mb-3 tw-max-w-none tw-text-sm tw-leading-6 tw-text-slate-700 md:tw-max-w-[70vw]">
                        {banner.descricao}
                    </p>
                )}

                <p className="tw-text-xs tw-text-slate-500">
                    Data: <Date date={banner.createdAt} />
                    <br />
                    criador:
                </p>

                <div className="tw-mt-4 tw-flex tw-flex-wrap tw-items-center tw-gap-3 md:tw-absolute md:tw-right-0 md:tw-top-0 md:tw-mt-0 md:tw-justify-end">
                    {banner.status === "Inactivo" && (
                        <span className="tw-text-sm tw-font-medium tw-text-red-600">Não publicado</span>
                    )}

                    <HeaderGestorConfigs
                        menu={false}
                        configArea={'banner'}
                        title={''}
                        banner={banner}
                        HandleEdit={onEdit}
                    />

                    <DeleteBanner
                        bannerId={banner._id}
                        setMessageSuccess={onDelete.setMessageSuccess}
                        setMessageError={onDelete.setMessageError}
                        setForceUpdate={onDelete.setForceUpdate}
                    />
                </div>
            </div>
        </div>
    </article>
)

export default function GestBanner() {
    const [title, setTitle] = useState('Criação')
    // const [banners, setNoticias] = useState('')
    const [editeBanner, setEditarNoticia] = useState(false)
    const [createBanner, setCreateBanner] = useState(false)
    const [message, setMessage] = useState('')
    const [messageError, seterrorMessage] = useState('')
    const [forceUpdate, setForceUpdate] = useState('')
    const [banners, setBanners] = useState('')

    useEffect(() => {
        api.get(`/carousels`)
            .then(response => {
                // console.log(response)
                setBanners(response.data.carousels);
            }).catch(error => {
                // console.log(error)
            })
    }, [createBanner, message, messageError])

    const HandleEdit = (banner) => {
        setEditarNoticia(banner)
    }

    return (
        <div className="tw-mx-auto tw-w-full tw-max-w-[1300px] tw-px-4 tw-py-6">
            <HeaderSession title={'GESTÃO DO BANNER'} />

            {message && <MessageSuccess message={message} />}
            {messageError && < MessageError message={messageError} />}

            <section className="tw-min-h-[95vh] tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-white tw-p-4 tw-shadow-sm sm:tw-p-6">

                {/* COMPONENTE DE CRIACAO DE NOTICIAS  */}
                {createBanner &&
                    <CreateBanner
                        title={title}
                        setTitle={setTitle}
                        setCreateBanner={setCreateBanner}
                        setMessage={setMessage}
                        seterrorMessage={seterrorMessage}
                    />
                }

                {(banners.length > 0 && !createBanner) &&
                    <>
                        <div className="tw-space-y-4">
                            <Slider forceUpdate={forceUpdate} />

                            <div className="tw-flex tw-items-center tw-justify-between tw-rounded-xl tw-bg-slate-50 tw-px-4 tw-py-3">
                                <span className="tw-text-sm tw-font-medium tw-text-slate-700">ADICIONAR NOVO SLIDER</span>
                                <button
                                    type="button"
                                    onClick={() => { setCreateBanner(true) }}
                                    className="tw-inline-flex tw-h-11 tw-w-11 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-slate-200 tw-bg-white tw-text-slate-700 tw-transition hover:tw-bg-slate-100"
                                    aria-label="Adicionar novo slider"
                                >
                                    <AddIcon />
                                </button>
                            </div>
                        </div>

                        <div className="tw-my-6 tw-h-px tw-bg-slate-200" />

                        <div className="tw-grid tw-gap-4">
                            {banners.map((banner) => (
                                <BannerCard
                                    key={banner._id}
                                    banner={banner}
                                    onEdit={HandleEdit}
                                    onDelete={{
                                        setMessageSuccess: setMessage,
                                        setMessageError: seterrorMessage,
                                        setForceUpdate,
                                    }}
                                />
                            ))}
                        </div>
                    </>
                }

                {!banners &&
                    <div className="tw-flex tw-items-center tw-justify-between tw-rounded-xl tw-bg-slate-50 tw-px-4 tw-py-3">
                        <span className="tw-text-sm tw-font-medium tw-text-slate-700">ADICIONAR SLIDER</span>
                        <button
                            type="button"
                            onClick={() => { setCreateBanner(true) }}
                            className="tw-inline-flex tw-h-11 tw-w-11 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-slate-200 tw-bg-white tw-text-slate-700 tw-transition hover:tw-bg-slate-100"
                            aria-label="Adicionar slider"
                        >
                            <AddIcon />
                        </button>
                    </div>
                }

                {!banners && <Loading text={'A carregar carrousel'} />}
            </section>

        </div>
    )
}